import { createSelector } from 'reselect'
import getNotesWorkoutUtil from 'modules/training/models/workout/utils/get-notes/index.js'
import { getByIdWorkoutSelector } from 'modules/workout/redux/selectors/index.js'

export default function getNotesByIdWorkoutSelector (id) {
  return createSelector(
    getByIdWorkoutSelector(id),
    workout => getNotesWorkoutUtil(workout)
  )
}
